import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import ContentContainer from 'common/containers/ContentContainer';
import SecurityHelmet from 'common/helmets/SecurityHelmet';

import 'css/components/_Policy.scss';

class Security extends Component {
  render() {
    return (
      <ContentContainer innerClassName="security card">
        <SecurityHelmet />
        <h1>Security</h1>
        <p>
          We take the security and privacy of your data on Canny very seriously. We understand the
          importance of keeping your data private and strive to keep it this way.
        </p>
        <h2>Compliance</h2>
        <p>Canny is SOC 2 certified. Our report is available on request.</p>
        <h2>Team</h2>
        <p>
          Our engineers have experience working on highly reliable, scalable, and secure systems at
          companies like Facebook and Google. We always have someone on call to address any issues
          or outages as fast as possible.
        </p>
        <h2>Hosting</h2>
        <p>
          Canny uses Amazon Web Services (AWS) to host all of our applications and static resources.
          They’re one of the top hosting providers in the world – used by companies like Netflix,
          Adobe, Snap, and Atlassian.
        </p>
        <p>
          Only Canny engineers have access to these machines, via key-based SSH login. We update
          system software whenever updates are available.
        </p>
        <p>
          To learn more, read about{' '}
          <a href="https://aws.amazon.com/security/" rel="noopener" target="_blank">
            AWS security policies
          </a>
          .
        </p>
        <h2>Data</h2>
        <p>
          Canny uses Atlas, a product of MongoDB, to host our data. We back-up everything
          continuously to ensure your valuable data stays safe.
        </p>
        <p>
          This data is only accessible by the same group of Canny engineers who have access to
          hosting machines. Your private data will not be accessed by our team except as absolutely
          needed to resolve issues.
        </p>
        <p>
          To learn more, read about{' '}
          <a href="https://www.mongodb.com/security" rel="noopener" target="_blank">
            MongoDB security policies
          </a>
          .
        </p>
        <h2>SSL</h2>
        <p>
          Our entire website and hosting servers are only accessible via encrypted connections –
          HTTPS using RSA 2048 bit keys.
        </p>
        <h2>Contact Us</h2>
        <p>
          If you have any remaining questions or concerns about Canny’s security, don’t hesitate to
          reach out to <a href="mailto:support@canny.io">support@canny.io</a>.
        </p>
      </ContentContainer>
    );
  }
}

export default hot(Security);
